export default __webpack_public_path__ + "static/media/cropped-mymove.3b6c492d.png";